// src/services/is-boolean.ts
function isBoolean(value) {
  return typeof value === "boolean";
}

// src/errors/non-parsable-boolean-value-error.ts
var NonParsableBooleanValueError = class extends Error {
  constructor(value) {
    super(`Unsupported boolean parsable value: ${value}`);
  }
};

// src/errors/non-parsable-string-to-boolean-error.ts
var NonParsableStringToBooleanValueError = class extends Error {
  constructor(value) {
    super(`Unsupported string to boolean parsable value: ${value}`);
  }
};

// src/services/parse-boolean.ts
function parseBoolean(value) {
  switch (typeof value) {
    case "boolean":
      return value;
    case "string":
      return parseBooleanFromString(value);
    case "number":
      return !!value;
    case "undefined":
      return false;
    default:
      throw new NonParsableBooleanValueError(value);
  }
}
function parseBooleanFromString(value) {
  const lowerCaseValue = value.toLowerCase();
  if (lowerCaseValue === true.toString()) {
    return true;
  }
  if (lowerCaseValue === false.toString()) {
    return false;
  }
  throw new NonParsableStringToBooleanValueError(value);
}
export {
  isBoolean,
  parseBoolean
};
